<div class="container-wrapper">


  <h2 matDialogTitle>Invite New User</h2>

  <mat-dialog-content>

    <!-- ── Success state ───────────────────────────────────────── -->
    <div *ngIf="sent" class="invite-success">
      <mat-icon class="invite-success__icon">mark_email_read</mat-icon>
      <p class="invite-success__title">Invite sent!</p>
      <p class="invite-success__sub">
        An activation link has been emailed to <strong>{{ form.value.email }}</strong>.
        The link expires in 48 hours.
      </p>

      <div class="invite-success__link-box" *ngIf="inviteLink">
        <span class="invite-success__link-text">{{ inviteLink }}</span>
        <button mat-icon-button matTooltip="Copy link" (click)="copyLink()">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    <!-- ── Form state ──────────────────────────────────────────── -->
    <div *ngIf="!sent" class="mat-step-spacer">
      <form [formGroup]="form">

        <!-- Email -->
        <mat-form-field class="input-group">
          <mat-label>Email address</mat-label>
          <input matInput formControlName="email" type="email" placeholder="user@example.com" autocomplete="off" />
          <mat-error *ngIf="form.get('email')?.hasError('required')">Email is required</mat-error>
          <mat-error *ngIf="form.get('email')?.hasError('email')">Enter a valid email</mat-error>
        </mat-form-field>
      </form>

      <!-- Only shown to superadmin -->
      <mat-form-field *ngIf="data.isSuperAdmin" appearance="fill" class="invite-dialog__email-field">
        <mat-label>Organization</mat-label>
        <mat-icon matPrefix>corporate_fare</mat-icon>
        <mat-select [(ngModel)]="selectedOrgId" (ngModelChange)="onOrgChange()">
          <mat-option [value]="null">
            <em>No organization (global user)</em>
          </mat-option>
          <mat-option *ngFor="let org of data.organizations" [value]="org.id">
            {{ org.org_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Permissions grouped by prefix -->
      <div *ngFor="let group of permissionGroups" class="perm-group">
        <div class="perm-group__label">{{ group.label }}</div>
        <div class="perm-group__chips">
          <div *ngFor="let perm of group.permissions" class="perm-chip"
            [class.perm-chip--selected]="selectedPermissionIds.has(perm.id)"
            [class.perm-chip--disabled]="isOrgScoped(perm) && !hasOrgContext"
            (click)="!isOrgScoped(perm) || hasOrgContext ? togglePermission(perm.id) : null">
            <mat-icon class="perm-chip__icon">
              {{ selectedPermissionIds.has(perm.id) ? 'check_circle' : 'radio_button_unchecked' }}
            </mat-icon>
            {{ perm.mpm_type.replace('.', ' ') }}
          </div>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="error" class="invite-error">
        <mat-icon>error_outline</mat-icon>
        {{ error }}
      </div>

    </div>

  </mat-dialog-content>

  <!-- ── Actions ─────────────────────────────────────────────── -->
  <mat-dialog-actions *ngIf="!sent">
    <button mat-flat-button (click)="onClose()" [disabled]="sending">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSendInvite()"
      [disabled]="form.invalid || sending || (data.isSuperAdmin && selectedOrgId === undefined)"
      style="max-width: 200px;">
      <mat-spinner *ngIf="sending" diameter="18" style="display:inline-flex; margin-right:6px;"></mat-spinner>
      <mat-icon *ngIf="!sending">send</mat-icon>
      {{ sending ? 'Sending...' : 'Send Invite' }}
    </button>
  </mat-dialog-actions>

  <mat-dialog-actions *ngIf="sent">
    <button mat-raised-button color="primary" (click)="onClose()" style="max-width: 200px;">
      Done
    </button>
  </mat-dialog-actions>

</div>